
import { WorldCountry } from './types';

export const jordanData: WorldCountry = {
  code: 'JO',
  name: 'Jordan',
  slug: 'jordan',
  population: 10203134,
  topCities: [
    { name: 'Amman', slug: 'amman', population: 4061150 },
    { name: 'Zarqa', slug: 'zarqa', population: 635160 },
    { name: 'Irbid', slug: 'irbid', population: 502714 },
    { name: 'Russeifa', slug: 'russeifa', population: 472604 },
    { name: 'Wadi as-Sir', slug: 'wadi-as-sir', population: 181212 },
    { name: 'Aqaba', slug: 'aqaba', population: 188160 },
    { name: 'Madaba', slug: 'madaba', population: 105353 },
    { name: 'Salt', slug: 'salt', population: 99890 },
    { name: 'Mafraq', slug: 'mafraq', population: 56340 },
    { name: 'Jerash', slug: 'jerash', population: 50745 }
  ]
};
